import React, { Fragment, useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import useRequests from "../../../utils/useRequests";
import Snackbars from "../../../utils/Snackbars";
import * as Yup from "yup";
import { useFormik } from "formik";

const EditStaff = () => {
    const { s_id } = useParams(); // Get the staff ID from the route params
    const navigate = useNavigate(); // For redirection
    const { getRequest, putRequest } = useRequests(); // Your custom hook for making API calls
    
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
    });
    const [AlertData, setAlertData] = React.useState({
        variant: '',
        message: '',
      });
    
      const resetAlertData = () => {
        setTimeout(() => {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: '',
            message: '',
          }));
        }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
      };
    
    const [loading, setLoading] = useState(true);
    const fetchStaffData = async () => {
        try {
            const response = await getRequest(`/staff/${s_id}`);
            console.log("Fetched staff data:", response); // Debug log
    
            if (response && Array.isArray(response.data) && response.data.length > 0) {
                // Access the first element of the data array
                const { first_name = "", last_name = "", email = ""} = response.data[0];
                setFormData({ first_name, last_name, email });
            } else {
                console.error("No staff data found in the response.");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching staff data:", error);
            setLoading(false);
        }
    };
    
    
    
    useEffect(() => {
        fetchStaffData();
    }, []);
    

   

     const validation1 = useFormik({
        enableReinitialize: true,
    initialValues: formData,
    
        validationSchema: Yup.object({

          first_name: Yup.string().required('First name is required'),
          last_name: Yup.string().required('Last name is required'),
          
        }),
       onSubmit: async ( values) => {
        // e.preventDefault();

        try {
            let submit1 = document.getElementById('submit1');
            submit1.disabled = true;
            submit1.textContent = ('Processing...');
            // Convert form data to JSON
            const jsonpar = JSON.stringify({
                first_name: values.first_name,
                last_name: values.last_name,
                
            });

            // Make the PUT request to update the staff
            const res = await putRequest(`staff-edit/${s_id}`, jsonpar);

            // Handle the response
            if (res && res.code === 200) {
              
                setFormData({
                    first_name: "",
                    last_name: "",
                    email: "",
                });
                navigate("/staff-list",{
                    state:{
                        variant: "success",
                        message: "Staff updated successfully!",
                    }
                }); // Redirect on success
            } else {
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: res.message || "Failed to update staff.",
                  }));
                  resetAlertData();
            }
            submit1.disabled = false;
            submit1.textContent = ('Update Staff');
        } catch (error) {
            console.error("Error: ", error);
          
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: "An error occurred while updating the staff.",
              }));
              resetAlertData();
        }
    }
     });

    if (loading) return <p>Loading...</p>;

    return (
        <Fragment>
            <div className="d-sm-flex d-block justify-content-between align-items-center mb-4">
                <h2 className="text-black font-w700 mb-0">Edit Staff</h2>
            </div>

            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="basic-form">
                            {AlertData.message !== "" ? (
                                     <Snackbars variant={AlertData.variant} message={AlertData.message} />
                                   ) : (
                                     ""
                                   )}
                            <form >
                                <div className="row mb-3">
                                    <div className="form-group mb-3 col-md-6 col-xs-12">
                                        <label>First Name:</label>
                                        <input
                                            type="text"
                                            className={`form-control ${validation1.touched.first_name && validation1.errors.first_name ? 'is-invalid' : ''}`}
                                            name="first_name"
                                            placeholder="Enter First Name"
                                            value={validation1.values.first_name || ''}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                            validation1.touched.first_name && validation1.errors.first_name ? true : false
                                            }
                                            
                                        />
                                        {validation1.touched.first_name && validation1.errors.first_name ? (
                                            <div className="invalid-feedback" >{validation1.errors.first_name}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-3 col-md-6 col-xs-12">
                                        <label>Last Name:</label>
                                        <input
                                            type="text"
                                            className={`form-control ${validation1.touched.last_name && validation1.errors.last_name ? 'is-invalid' : ''}`}
                                            name="last_name"
                                            placeholder="Enter Last Name"
                                            value={validation1.values.last_name}
                                            onChange={validation1.handleChange}
                                            onBlur={validation1.handleBlur}
                                            invalid={
                                            validation1.touched.last_name && validation1.errors.last_name ? true : false
                                            }
                                            
                                        />
                                        {validation1.touched.last_name && validation1.errors.last_name ? (
                                            <div className="invalid-feedback" >{validation1.errors.last_name}</div>
                                        ) : null}
                                    </div>
                                    <div className="form-group mb-3 col-md-6 col-xs-12">
                                        <label>Email:</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            name="email"
                                            placeholder="Enter Email"
                                            value={formData.email}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="btn btn-primary me-2"
                                id="submit1"onClick={(e) => {
                                    e.preventDefault();
                                    validation1.handleSubmit();
                                    return false;
                                  }}>
                                  {('Update Staff')}
                                </button>
                                <Link to="/staff-list" className="btn btn-light">
                                    Cancel
                                </Link>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default EditStaff;
